import Vue from "vue";
import Router from "vue-router";

import DefaultLayout from "@/components/layouts/DefaultLayout";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: DefaultLayout,
      meta: { requiresAuth: true },
      redirect: "/principal",
      children: [
        {
          path: "/principal",
          name: "home",
          meta: { client: true },
          component: () =>
            import(/* webpackChunkName: "home" */ "@/views/Home.vue")
        },
        {
          path: "/usuarios",
          name: "user-list",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/Users.vue")
        },
        {
          path: "/usuarios/crear",
          name: "user-create",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/UserEdit.vue")
        },
        {
          path: "/usuarios/:id",
          name: "user-edit",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/UserEdit.vue")
        },
        {
          path: "/pc-autorizados",
          name: "computer-list",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/Computers.vue")
        },
        {
          path: "/pc-autorizados/crear",
          name: "computer-create",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/ComputerEdit.vue")
        },
        {
          path: "/pc-autorizados/:id",
          name: "computer-edit",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/ComputerEdit.vue")
        },
        {
          path: "/parques",
          name: "farm-list",
          meta: { client: true },
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/Farms.vue")
        },
        {
          path: "/parques/crear",
          name: "farm-create",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/FarmEdit.vue")
        },
        {
          path: "parques/:id",
          name: "farm-edit",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/FarmEdit.vue")
        },
        {
          path: "/cajas-sensores",
          name: "sensors-list",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/SensorsBoxes.vue")
        },
        {
          path: "/cajas-sensores/crear",
          name: "sensors-create",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/SensorsBoxEdit.vue")
        },
        {
          path: "cajas-sensores/:id",
          name: "sensors-edit",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/SensorsBoxEdit.vue")
        },
        {
          path: "cajas-sensores/:id/datos",
          name: "sensors-data",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/SensorsBoxData.vue")
        },
        {
          path: "/clientes",
          name: "client-list",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/Clients.vue")
        },
        {
          path: "/clientes/crear",
          name: "client-create",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/ClientEdit.vue")
        },
        {
          path: "clientes/:id",
          name: "client-edit",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/ClientEdit.vue")
        },
        {
          path: "/adjudicaciones",
          name: "contract-list",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/Contracts.vue")
        },
        {
          path: "/adjudicaciones/crear",
          name: "contract-create",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/ContractEdit.vue")
        },
        {
          path: "adjudicaciones/:id",
          name: "contract-edit",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/ContractEdit.vue")
        },
        {
          path: "/ordenes-trabajo",
          name: "order-list",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/WorkOrders.vue")
        },
        {
          path: "/ordenes-trabajo/crear",
          name: "order-create",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/WorkOrdersEdit.vue")
        },
        {
          path: "/ordenes-trabajo/:id",
          name: "order-edit",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/WorkOrdersEdit.vue")
        },
        {
          path: "/revision-intervenciones",
          name: "intervention-review-list",
          meta: { client: true },
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/InterventionReview.vue")
        },
        {
          path: "/revision-intervenciones/ordenes-trabajo/:work_order/intervenciones/:id",
          name: "intervention-review-edit",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/InterventionReviewEdit.vue")
        },
        {
          path: "/informes",
          name: "report-list",
          meta: { client: true },
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/Reports.vue")
        },
        {
          path: "/informes/crear",
          name: "report-create",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/ReportsEdit.vue")
        },
        {
          path: "/informes/:id",
          meta: { client: true },
          name: "report-edit",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/ReportsEdit.vue")
        },
        {
          path: "/otros-informes/:report",
          name: "others-reports",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/OthersReports/index.vue")
        },
        {
          path: "/mi-perfil",
          name: "my-profile",
          component: () =>
            import(/* webpackChunkName: "users" */ "@/views/Profile.vue")
        }
      ]
    },
    {
      path: "/entrar",
      name: "login",
      meta: { guest: true },
      component: () => import("./views/Login.vue")
    },
    {
      path: "/recuperar",
      name: "password-recover",
      meta: { guest: true },
      component: () => import("./views/LoginRecovery.vue")
    },
    {
      path: "*",
      component: () =>
        import(
          /* webpackChunkName: "errors-404" */ "@/views/error/NotFound.vue"
        )
    }
  ]
});

router.beforeEach((to, from, next) => {
  const roles = JSON.parse(localStorage.getItem('roles')) || []
  const isClient = roles.includes('Cliente')

  if (isClient && !to.meta.client) {
    next({ name: 'home' })
  }
  else if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem("token") == null) {
      next({
        path: "/entrar",
        params: { nextUrl: to.fullPath }
      });
    } else {
      next();
    }
  }
  else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem("token") == null) {
      next();
    } else {
      next({ name: "general" });
    }
  }
  else {
    next();
  }
});

export default router;
